import cn from 'classnames';
import { formatMoney } from 'shared/util/formatting';
import type { Money } from 'shared/util/money';

type PriceDetailProps = {
    title: string;
    isTotal?: boolean;
} & ({ money: Money; value?: never } | { value: string; money?: never });

export const PriceDetail = ({ title, money, value, isTotal = false }: PriceDetailProps) => (
    <>
        {isTotal && <hr className="divider my-16" />}
        <div className={cn('flex justify-between my-8 text-14', { 'font-bold': isTotal })}>
            <dt className="m-0">{title}</dt>
            <dd className="m-0">{money ? <data value={money.value}>{formatMoney(money, 2)}</data> : value}</dd>
        </div>
    </>
);
